// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip[data-v-16ff2366] {
  position: relative;
  display: inline-block;
}
.tooltip .tooltiptext[data-v-16ff2366] {
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: absolute;
  bottom: 20px;
  z-index: 1;
}
.tooltip:hover .tooltiptext[data-v-16ff2366] {
  visibility: visible;
}
.flags[data-v-16ff2366] {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.flags-approved-status[data-v-16ff2366] {
  background-color: green;
}
.flags-deleted-status[data-v-16ff2366] {
  background-color: red;
}
.flags-blocked-status[data-v-16ff2366] {
  background-color: red;
}
.flags-pending-status[data-v-16ff2366] {
  background-color: yellow;
}
.flags-warning-status[data-v-16ff2366] {
  background-color: orange;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/components/community/chatrooms/comments/MessageFlags.vue","webpack://./MessageFlags.vue"],"names":[],"mappings":"AAEE;EACE,kBAAA;EACA,qBAAA;ACDJ;ADIE;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAEA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;ACFJ;ADKE;EACE,mBAAA;ACFJ;ADKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACFJ;ADII;EACE,uBAAA;ACFN;ADKI;EACE,qBAAA;ACHN;ADKI;EACE,qBAAA;ACHN;ADMI;EACE,wBAAA;ACJN;ADOI;EACE,wBAAA;ACLN","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n  .tooltip {\n    position: relative;\n    display: inline-block;\n  }\n\n  .tooltip .tooltiptext {\n    visibility: hidden;\n    width: 200px;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0;\n\n    /* Position the tooltip */\n    position: absolute;\n    bottom: 20px;\n    z-index: 1;\n  }\n\n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n  }\n\n  .flags {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n\n    &-approved-status {\n      background-color: green;\n    }\n\n    &-deleted-status{\n      background-color: red;\n    }\n    &-blocked-status{\n      background-color: red;\n    }\n\n    &-pending-status {\n      background-color: yellow;\n    }\n\n    &-warning-status {\n      background-color: orange;\n    }\n  }\n",".tooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 200px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  /* Position the tooltip */\n  position: absolute;\n  bottom: 20px;\n  z-index: 1;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n}\n\n.flags {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n.flags-approved-status {\n  background-color: green;\n}\n.flags-deleted-status {\n  background-color: red;\n}\n.flags-blocked-status {\n  background-color: red;\n}\n.flags-pending-status {\n  background-color: yellow;\n}\n.flags-warning-status {\n  background-color: orange;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
